export const popMixin = {
  data() {
    return {
      message: "",
      showPop: false,
    };
  },
  methods: {
    showMessage(time, msg) {
      this.showPop = true;
      this.message = msg;
      setTimeout(() => {
        this.showPop = false;
      }, time);
    },
  },
}